export const noDataValue = {text: 'No data', value: null, type: 'noDataValue'}
